export const platformList = [
  {
    type: 'all',
    class: '所有平台'
  }, {
    type: 'wx',
    class: '微信'
  }, {
    type: 'wb',
    class: '微博'
  }, {
    type: 'zh',
    class: '知乎'
  }, {
    type: 'tt',
    class: '头条'
  }, {
    type: 'qeh',
    class: '企鹅号'
  }, {
    type: 'shh',
    class: '搜狐号'
  }, {
    type: 'wyh',
    class: '网易号'
  }, {
    type: 'ydh',
    class: '一点号'
  }, {
    type: 'bjh',
    class: '百家号'
  }, {
    type: 'xlkdh',
    class: '新浪看点号'
  }, {
    type: 'dfh',
    class: '大风号'
  }, {
    type: 'xqh',
    class: '雪球号'
  }, {
    type: 'pph',
    class: '澎湃号'
  }
]

export const platMap = (function () {
  const result = {}
  platformList.forEach(item => {
    result[item.type] = item.class
  })
  return result
})()


// WEBPACK FOOTER //
// src/routes/cms/components/BrandComponent/enmu.js